import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout'
import { ChangeDetectorRef, Component } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { PropertyInquiryGQL, PropertyInquiryRequest, TrackingContext } from '../../../../../graphql'
import { breakpoints, oneMicro } from '../../../../constant'
import { Amplitude } from '../../../../injectable'
import { CurrencyService } from '../../../../injectable/currency-service'
import { getCookie, UnsubscribeOnDestroy } from '../../../../utility'

interface FormFields {
    requirementsDescription: string
    checkin?: string
    checkout?: string
    contactMethod: 'phone' | 'email'
    numberOfGuests: number
    tripBudget: string
}

@Component({
    selector: 'app-property-inquiry-contact-form',
    templateUrl: 'property-inquiry-contact-form.html'
})
export class PropertyInquiryContactFormComponent extends UnsubscribeOnDestroy {

    contactForm: FormGroup
    formIsValid = false
    checkinDate: string
    checkoutDate: string
    submitting = false
    submitSuccess = false
    submitError = false
    mobileView = false
    formFields = {} as FormFields
    currency: string

    constructor(
        private readonly _changeDetector: ChangeDetectorRef,
        private _breakpointObserver: BreakpointObserver,
        private _propertyInquiryGQL: PropertyInquiryGQL,
        private _currencyService: CurrencyService,
        private _amplitude: Amplitude) {

        super()

        this.currency = this._currencyService.getPresentmentCurrency()

        this.contactForm = new FormGroup({})

        this.contactForm.valueChanges.subscribe(() => {
            this.formIsValid = this.contactForm.status === 'VALID'
            this._changeDetector.detectChanges()
        })

        this._breakpointObserver.observe([
                `(max-width: ${breakpoints.smMax})`
            ]).subscribe((result: BreakpointState) => {
                this.mobileView = result.matches
            })
    }

    updateTravelDates($event: {checkin: string, checkout: string}) {
        this.checkinDate = $event?.checkin
        this.checkoutDate = $event?.checkout
    }

    onSubmit() {
        if (this.checkinDate && this.checkoutDate) {
            this.formFields.checkin = this.checkinDate
            this.formFields.checkout = this.checkoutDate
        }

        // tslint:disable-next-line:forin
        for (const field in this.contactForm.controls) {
            this.formFields[field] = this.contactForm.controls[field].value
        }

        this.postData()
    }

    postData() {

        this.submitting = true

        const propertyInquiryRequest: PropertyInquiryRequest = {
            requirementsDescription: this.formFields?.requirementsDescription,
            checkin: this.checkinDate,
            checkout: this.checkoutDate,
            contactMethod: this.formFields?.contactMethod,
            numberOfGuests: this.formFields?.numberOfGuests ?? 1,
            tripBudget: {
                currency: this.currency,
                amountMicros: Number.parseInt(this.formFields.tripBudget, 10) * oneMicro
            },
            context: this.getHubSpotContext()
        }

        this._propertyInquiryGQL
            .mutate({ input: propertyInquiryRequest })
            .subscribe(response => {
                if (response.errors && response.errors.length) {
                    console.log('Error submitting Property Inquiry HubSpot form data', JSON.stringify(response.errors))
                    this.submitError = true
                    this._amplitude.logEvent('Property Inquiry Failed')
                    return
                }

                this.submitting = false
                this.submitSuccess = true
                this._amplitude.logEvent('Property Inquiry Success')
        })
    }

    private getHubSpotContext(): TrackingContext {
        return {
            userId: getCookie('hubspotutk'),
            pageUri: window.location.href,
            pageName: window.location.href.split('/').slice(-1)[0]
        } as TrackingContext
    }
}
